export const defaultInstitution = {
  code: '',
  name: '',
  email: '',
  isSyncContent: true,
};
